import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Phone } from 'lucide-react';
import { footerData } from '../../data/mock';

const Footer = () => {
  const footerLinks = {
    layanan: [
      { name: 'Canva Team Pro', href: '#' },
      { name: 'Google Workspace', href: '#' },
      { name: 'Zoom Premium', href: '#' },
      { name: 'Web Hosting', href: '#' },
    ],
    organisasi: [
      { name: 'Tentang Kami', href: '#' },
      { name: 'Tim Dirpusdadig', href: '#' },
      { name: 'Kebijakan', href: '#' },
    ],
    bantuan: [
      { name: 'FAQ', href: '#' },
      { name: 'Panduan', href: '#' },
      { name: 'Kontak', href: '#' },
    ],
  };

  return (
    <footer className="relative bg-gray-900">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="flex items-center gap-3 mb-6"
            >
              <img 
                src="/logo-pusdadig.png" 
                alt="Dirpusdadig PPI Dunia" 
                className="w-12 h-12 rounded-xl object-contain"
              />
              <div>
                <h3 className="text-white font-semibold text-xl">Dirpusdadig</h3>
                <p className="text-gray-400 text-sm">PPI Dunia</p>
              </div>
            </motion.div>
            <p className="text-gray-400 mb-4 max-w-sm leading-relaxed">
              Direktorat Pusat Data & Digitalisasi - Menyediakan infrastruktur teknologi untuk pelajar Indonesia di seluruh dunia.
            </p>
            <p className="text-gray-400 mb-6 max-w-sm leading-relaxed text-sm">
              Dirpusdadig adalah bagian dari <span className="text-red-400 font-medium">Perkumpulan Pelajar Indonesia Sedunia</span>
            </p>
            <div className="flex flex-col gap-3">
              <a href="mailto:dirpusdadig@ppi.id" className="flex items-center gap-3 text-gray-400 hover:text-red-400 transition-colors">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm">dirpusdadig@ppi.id</span>
              </a>
              <a href="https://wa.me/6285833335555" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-green-400 transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm">+6285833335555</span>
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <div className="text-sm leading-relaxed">
                  <p>Jalan Kirai, 07, RT 002/RW 001, Cipete Utara, Kebayoran Baru</p>
                  <p>Kota Administrasi Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12150</p>
                  <p>Indonesia</p>
                </div>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="text-white font-semibold mb-4">Layanan</h4>
            <ul className="space-y-3">
              {footerLinks.layanan.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Organisasi</h4>
            <ul className="space-y-3">
              {footerLinks.organisasi.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Bantuan</h4>
            <ul className="space-y-3">
              {footerLinks.bantuan.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              {footerData.copyright}
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-white transition-colors text-sm">
                Kebijakan Privasi
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors text-sm">
                Syarat & Ketentuan
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Gradient */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-500/50 to-transparent" />
    </footer>
  );
};

export default Footer;
